import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import { setIsLoading, setIsWaiting, setShowComponent } from '../../../../actions/general';
import { API_SUBSCRIBER_USER_COURSE_TEST, TAKE_TEST_RESULT } from '../../../../constants';
import { fetchUserTestsRequest } from '../../Subscriber/MyCECertificates/actions';
import { setUserTests } from '../MyCECertificates/actions';
import { fetchSubscriberCourseDetailsRequest } from '../MyLeaning/actions';

export const SET_TAKE_TEST = 'setTakeTest';

export const API_SUBSCRIBER_TAKE_TEST = 'take-test/:testId';
export const API_SUBSCRIBER_USER_TEST = 'user/test';

export const setTakeTest = (test) => {
     return {
          type: SET_TAKE_TEST,
          payload: test,
     };
};

export const fetchSubscriberTakeTestRequest = (testId) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_TAKE_TEST.replace(':testId', testId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setTakeTest(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const fetchSubscriberUserTestRequest = (courseId, testId, nextDispatch) => (dispatch, getState) => {
     const { setRunSubmit, runSubmit, setUserTakeTests } = nextDispatch;

     const userTests = getState().subscriber.userTests;
     if (!userTests) {
          dispatch(fetchUserTestsRequest());
     }

     const listUserTestId =
          userTests?.map((userTest) => {
               return userTest.id;
          }) ?? [];

     const newListUserTest = userTests ? [...userTests] : [];

     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_USER_COURSE_TEST.replace(':courseId', courseId).replace(':testId', testId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    const newUserTests = response.data;
                    setUserTakeTests(newUserTests);
                    newUserTests.forEach((userTest) => {
                         if (listUserTestId && !listUserTestId.includes(userTest.id)) {
                              newListUserTest.push(userTest);
                         }
                    });
                    dispatch(setUserTests(newListUserTest));
               }
          })
          .finally(() => {
               if (runSubmit) {
                    dispatch(setShowComponent(TAKE_TEST_RESULT));
               }
               dispatch(setIsLoading(false));

               setRunSubmit(false);
          });
};

export const checkSubscriberTestQuestion = (newValues, nextDispatch) => (dispatch) => {
     const {
          userTest,
          question,
          stepQuestion,
          countQuestions,
          resetForm,
          resultTest,
          setResultTest,
          setSelectedAnswer,
          setValueAnswers,
          setStepQuestion,
          setRunSubmit,
          setSubmitting,
          fetchUserTakeTests,
          timeStart,
     } = nextDispatch;

     if (!newValues.answer || newValues.answer.length <= 0) {
          setSelectedAnswer('You must select or fill in at least 1 answer');
          setSubmitting(false);

          return;
     }

     setValueAnswers([]);
     const isQuestion = resultTest.filter((item) => {
          return item.questionId === question.id;
     });

     if (isQuestion.length === 0) {
          setResultTest([...resultTest, newValues]);
     } else {
          const newResultTest = resultTest.map((item) => {
               if (item.questionId === question.id) {
                    return newValues;
               }
               return item;
          });

          setResultTest(newResultTest);
     }

     resetForm();

     if (stepQuestion < countQuestions - 1) {
          setStepQuestion(stepQuestion + 1);
     } else {
          let completeTest = [];

          //check choice answer again
          if (resultTest.some((res) => res.questionId === question.id)) {
               completeTest = [...resultTest];
               completeTest[countQuestions - 1] = {
                    questionId: question.id,
                    answer: newValues.answer,
               };
          } else {
               completeTest = [...resultTest, newValues];
          }
          // setResultTest([...completeTest]);

          const userTestResult = { ...userTest, completeTest };

          const payload = {
               ...userTestResult,
               timeStart,
          };

          dispatch(setIsWaiting(true));
          callApi(API_SUBSCRIBER_USER_TEST, 'POST', payload)
               .then((response) => {
                    if (response.status === 200) {
                         setRunSubmit();
                         setStepQuestion(0);
                         setResultTest([]);
                         dispatch(fetchSubscriberCourseDetailsRequest(userTest.courseId));
                         fetchUserTakeTests();
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    dispatch(setIsWaiting(false));
                    dispatch(setShowComponent(TAKE_TEST_RESULT));
               });
     }
};

const saveAnswerSelected = (question, answer, resultTest, setResultTest) => () => {
     const newValues = {
          questionId: question.id,
          answer,
     };

     const isQuestion = resultTest.filter((item) => {
          return item.questionId === question.id;
     });

     if (isQuestion.length === 0) {
          setResultTest([...resultTest, newValues]);
     } else {
          const newResultTest = resultTest.map((item) => {
               if (item.questionId === question.id) {
                    return newValues;
               }
               return item;
          });

          setResultTest(newResultTest);
     }
};

export const changeSubscriberSelectTestAnswer = (nextDispatch) => (dispatch) => {
     const { event, question, resultTest, setResultTest, valueAnswers, setValueAnswers, setFieldValue, setSelectedAnswer } = nextDispatch;

     const valueSelect = event.target.value;
     const newAnswers = [...valueAnswers];

     if (event.target.checked) {
          newAnswers.push(valueSelect);
     } else {
          const key = newAnswers.findIndex((value) => value === valueSelect);
          newAnswers.splice(key, 1);
     }

     setValueAnswers(newAnswers);
     setFieldValue('answer', newAnswers);
     setSelectedAnswer('');

     dispatch(saveAnswerSelected(question, newAnswers, resultTest, setResultTest));
};

export const changeSubscriberInputTestAnswer = (newAnswers, nextDispatch) => (dispatch) => {
     const { question, resultTest, setResultTest, setFieldValue, setSelectedAnswer } = nextDispatch;

     dispatch(saveAnswerSelected(question, newAnswers, resultTest, setResultTest));
     setFieldValue('answer', newAnswers);
     setSelectedAnswer('');
};

export const changeSubscriberRadioTestAnswer = (radioValue, nextDispatch) => (dispatch) => {
     const { question, radioName, resultTest, setResultTest, setFieldValue, setSelectedAnswer } = nextDispatch;
     dispatch(saveAnswerSelected(question, radioValue, resultTest, setResultTest));
     setFieldValue(radioName, radioValue);
     setSelectedAnswer('');
};

//TP-195 add test mode, action autoCompletePass
export const autoCompleteRequest = (resultTest, nextDispatch) => (dispatch) => {
     const { userTest, fetchUserTakeTests } = nextDispatch;

     let completeTest = [...resultTest];
     const userTestResult = { ...userTest, completeTest };
     callApi(API_SUBSCRIBER_USER_TEST, 'POST', userTestResult)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(fetchSubscriberCourseDetailsRequest(userTest.courseId));
                    fetchUserTakeTests();
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowComponent(TAKE_TEST_RESULT));
          });
};
